import { FC, PropsWithChildren, useMemo } from 'react';
import { useLocation } from 'react-router';
import { create } from 'zustand';
import { useCatalogue } from '../api/hooks/catalog';
import { AdminCatalogueConfiguration, CompanyCatalogueConfiguration, PartnerCatalogueConfiguration } from './catalogue';
import { CatalogueContext, CatalogueService } from './useCatalogueService';

interface CatalogueProviderProps {
  configuration: CompanyCatalogueConfiguration | PartnerCatalogueConfiguration | AdminCatalogueConfiguration;
  purchaseOrder?: boolean;
}

export const CatalogueProvider: FC<PropsWithChildren<CatalogueProviderProps>> = ({ children, configuration, purchaseOrder }) => {
  const [catalogue] = useCatalogue(configuration);

  const location = useLocation().pathname;

  const store = useMemo(
    () =>
      create<CatalogueService>(set => ({
        configuration,
        filterPackId: catalogue?.filterPack?.id,
        showLatest: false,
        setShowLatest: showLatest => {
          set({ showLatest: showLatest });
        },
        inPurchaseOrder: !!purchaseOrder
      })),
    [configuration, catalogue?.filterPack?.id, location]
  );

  return <CatalogueContext.Provider value={store}>{children}</CatalogueContext.Provider>;
};
